import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/HomeScreen.css';

const HomeScreen: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <div className="video-overlay"></div>
      <video className="background-video" autoPlay loop muted playsInline>
        <source
          src="https://redrocket.energy/wp-content/uploads/2024/05/RedRocketAnimation1200p_Loop.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="home-content"
      >
        <h1>Welcome to Red Rocket</h1>
        <motion.img 
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
          src="https://redrocket.energy/wp-content/uploads/2021/03/rr-emblem.svg" 
          alt="Red Rocket Logo" 
          className="logo" 
        />
        {/* <h2 className="subheading">Register below</h2> */}
        <div className="button-container">
          <motion.button
            onClick={() => navigate('/visitor-sign-in')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="action-button primary-button"
          >
            <i className="fas fa-user-plus"></i>
            New Visitor
          </motion.button>
          <motion.button
            onClick={() => navigate('/quick-lookup')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="action-button secondary-button"
          >
            <i className="fas fa-search"></i>
            Returning Visitor
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default HomeScreen; 